import { render, staticRenderFns } from "./allTypesFile.vue?vue&type=template&id=62361306"
import script from "./allTypesFile.vue?vue&type=script&lang=js"
export * from "./allTypesFile.vue?vue&type=script&lang=js"
import style0 from "./allTypesFile.vue?vue&type=style&index=0&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports